import EasyMDE from "easymde";

function initEasyMDE() {
  document.querySelectorAll('.thredded--form textarea[name$="[content]"]').forEach((textarea) => {
    if (textarea.dataset.easymdeInit) return;
    textarea.dataset.easymdeInit = "true";
    textarea.removeAttribute("required");

    new EasyMDE({
      element: textarea,
      spellChecker: false,
      status: false,
      autoDownloadFontAwesome: true,
      placeholder: "Write your post using Markdown...",
      toolbar: [
        "bold", "italic", "heading", "|",
        "code", "quote", "unordered-list", "ordered-list", "|",
        "link", "image", "upload-image", "|",
        "preview", "side-by-side", "fullscreen", "|",
        "guide"
      ],
      uploadImage: true,
      imageMaxSize: 1024 * 1024,
      imageAccept: "image/png, image/jpeg, image/gif, image/webp",
      imageUploadEndpoint: "/api/forum_uploads",
      imagePathAbsolute: true,
      renderingConfig: {
        codeSyntaxHighlighting: false,
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", initEasyMDE);
document.addEventListener("turbo:load", initEasyMDE);
document.addEventListener("turbo:frame-load", initEasyMDE);
